//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import { makeStyles } from "@material-ui/core/styles";

export const footerStyles = makeStyles((theme) => ({
  ref: {
    textAlign: "center",
    color: "#2F7CBD",
    fontSize: "0.75rem",
    padding: 10,
    cursor: "pointer",
    fontWeight: "bold",
  },
  mainDiv: {
    backgroundColor: "#f4f4f4",
    position: "sticky",
    top: "100%",
    padding: 10,
  },
  secondDiv: {
    height: "60px",
    position: "relative",
    display: "block",
  },
  gridContainer: {
    height: "inherit",
  },
  gridItem: {
    alignSelf: "center",
    textAlign: "center",
  },
  socialIconDivTwo: {
    display: "flex",
    alignItems: "center"
  },
  socialIconDivOne: {
    float: "right",
    position: "absolute",
    top: "34%",
    right: "5%",
    "@media (max-width: 900px)": {
      top: "110%",
      paddingBottom: "10px",
    },
    "@media (max-width: 600px)": {
      right: "35%",
    }
  },
  socialIconAtag: {
    fontSize: 20,
    marginRight: 5,
  },
  facebookFilled: {
    color: "#3765a3",
    "&:hover": {
      color: "red"
    }
  },
  twitterFilled: {
    color: "#659fcb",
    "&:hover": {
      color: "red"
    }
  },
  linkedInFilled: {
    color: "#0177b5",
    "&:hover": {
      color: "red"
    }
  }
}));
